// extracted by mini-css-extract-plugin
export default {"header":"RegisterAttendancesList_header__KSQKy","titleHeader":"RegisterAttendancesList_titleHeader__phAYW","icon":"RegisterAttendancesList_icon__Q2W7X"};